import { Award, Users, Clock, Shield, ArrowRight } from "lucide-react"

function AboutPreview() {
  const stats = [
    { icon: Clock, number: "15+", label: "Yıl Deneyim" },
    { icon: Users, number: "2500+", label: "Mutlu Müşteri" },
    { icon: Award, number: "50+", label: "Tamamlanan Proje" },
    { icon: Shield, number: "100%", label: "Güvenli Montaj" },
  ]

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Neden Bizi Tercih Etmelisiniz?</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  2009 yılından bu yana doğalgaz tesisat sektöründe faaliyet gösteren firmamız, güvenli ve kaliteli
                  hizmet anlayışı ile binlerce müşteriye hizmet vermiştir.
                </p>
                <p>
                  Uzman kadromuz ve modern ekipmanlarımız ile evlerde, işyerlerinde ve sanayi tesislerinde doğalgaz
                  tesisat çözümleri sunmaktayız.
                </p>
              </div>
              <div className="mt-6">
                <a
                  href="/hakkimizda"
                  className="inline-flex items-center px-6 py-3 text-blue-600 bg-transparent border border-blue-600 hover:bg-blue-50 rounded-md transition-colors duration-200"
                >
                  Daha Fazla Bilgi
                  <ArrowRight className="ml-2 h-4 w-4" />
                </a>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="text-center p-6 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="mx-auto bg-blue-100 p-3 rounded-full w-12 h-12 flex items-center justify-center mb-3">
                  <stat.icon className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">{stat.number}</p>
                  <p className="text-sm text-gray-600">{stat.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutPreview
